module.exports = __webpack_public_path__ + "img/banner-7-en.ce38a249.png";